module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Clark_CR-p-500-1d425effe782c13ec178f984b0984ca6.jpg";